import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { colors, rem, typography, getResetByTag, utilityStyles } from './../../styles';
import StyledAlertBody from './components/alert-body/alert.body.styles';
import StyledDivider from '../divider/divider.styles';
var alertStyles = function alertStyles() {
  return /*#__PURE__*/css("background-color:", colors.coolGray_300, ";border-color:", colors.coolGray_800, ";border-style:solid;border-width:", rem(1), ";display:flex;padding:", rem(12, 12, 12, 8), ";padding-right:0;position:relative;" + (process.env.NODE_ENV === "production" ? "" : ";label:alertStyles;"));
};
var isDismissibleStyles = function isDismissibleStyles(_ref) {
  var dismissible = _ref.dismissible;
  if (dismissible) {
    return /*#__PURE__*/css(StyledAlertBody, " padding-right:", rem(24), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isDismissibleStyles;"));
  }
};
var sizeStyles = function sizeStyles(_ref2) {
  var size = _ref2.size;
  switch (size) {
    case 'lg':
      return /*#__PURE__*/css("padding:", rem(16), ";", StyledAlertBody, "{font-size:", typography.typographyBodyLg, ";margin-top:", rem(6), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'sm':
      return /*#__PURE__*/css(StyledAlertBody, "{font-size:", typography.typographyBodySm, ";margin-top:", rem(2), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
  }
};
var variantStyles = function variantStyles(_ref3) {
  var variant = _ref3.variant;
  switch (variant) {
    case 'critical':
      return /*#__PURE__*/css("background-color:", colors.red_100, ";border-color:", colors.red_500, ";", StyledDivider, "{border-top-color:", colors.red_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'caution':
      return /*#__PURE__*/css("background-color:", colors.yellow_100, ";border-color:", colors.yellow_800, ";", StyledDivider, "{border-top-color:", colors.yellow_800, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'success':
      return /*#__PURE__*/css("background-color:", colors.green_100, ";border-color:", colors.green_700, ";", StyledDivider, "{border-top-color:", colors.green_700, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'information':
      return /*#__PURE__*/css("background-color:", colors.lightBlue_100, ";border-color:", colors.blue_500, ";", StyledDivider, "{border-top-color:", colors.blue_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    default:
      return /*#__PURE__*/css("border-color:", colors.coolGray_800, ";", StyledDivider, "{border-top-color:", colors.coolGray_800, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledAlert = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1052g4h0"
} : {
  target: "e1052g4h0",
  label: "StyledAlert"
})(resetStyles, alertStyles, isDismissibleStyles, variantStyles, sizeStyles, utilityStyles);
export default StyledAlert;